import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { ScheduleSettingsDialog } from 'modules/engagement_surveys/components/SurveyResourceHeader/ScheduleSettingsDialog'

type Data = {
  formId: string
}

export const ScheduleSettingsActivity: ActivityComponent<Data> = ({ formId }) => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  return <ScheduleSettingsDialog formId={formId} onClose={closeActivity} />
}
